//
// 单选框
// ============================================================
import Ns from "./utility";

const Radio = () => new Ns({
    el: ".radio-wrapper",
    eventHandle: {
        type: "click",
        entrust: ".radio-group",
        callback:  function (ev) {

            // 禁用状态
            if(ns(this).hasClass("disabled")){
                ns(this).attr("title", "禁用状态");
                return true;
            }

            // 定义图标
            let userDefinedDefault = ns(this).parents(".radio-wrapper").attr("data-icon-default");
            let userDefinedChecked = ns(this).parents(".radio-wrapper").attr("data-icon-checked");
            let isUserDefinedChecked = !userDefinedChecked ? "icon-radiobox" : userDefinedChecked;
            let isUserDefinedDefault = !userDefinedDefault ? "icon-round" : userDefinedDefault;

            if (!ns(this).find(".iconfont").hasClass(isUserDefinedChecked)){
                // 恢复默认值
                ns(this).parents(".radio-wrapper").find(".radio-group").attr("data-radio-checked", false);
                ns(this).parents(".radio-wrapper").find(".iconfont").removeClass(isUserDefinedChecked).addClass(isUserDefinedDefault);

                // 选中
                ns(this).find(".iconfont").removeClass(isUserDefinedDefault).addClass(isUserDefinedChecked);
                let radioId = ns(this).attr("data-radio-checked", true).attr("data-radio-id");
                ns(this).parents(".radio-wrapper").attr("data-radio-checked-id", radioId)
            }
            return true;
        },
    },
    load() {
        Ns.each(ns(this).find(".radio-group[data-radio-checked=true]").get(), item => {
            let iconChecked = ns(item).parents(".radio-wrapper").attr("data-icon-checked");
            let iconDefault = ns(item).parents(".radio-wrapper").attr("data-icon-default");

            if (!iconChecked) {
                iconChecked = "icon-radiobox"
            }
            if (!iconDefault) {
                iconDefault = "icon-round"
            }

            let radioId= ns(item).attr("data-radio-id");

            ns(item).find(".iconfont").removeClass(iconDefault).addClass(iconChecked);
            ns(item).parents(".radio-wrapper").attr("data-radio-checked-id", radioId);
        })
    },
});

module.exports = Radio;


// WEBPACK FOOTER //
// src/js/radio.js